module.exports = __webpack_public_path__ + "img/code4.d901949f.png";